import React, {useState} from "react";
import AjaxFunctions from "../ajaxFunctions";
import Utils from "../utils";
import * as ToastAlert from "../components/toastAlert";
import {Button, Typography} from "@material-ui/core";
import {MultiLineTextField} from "../components/commonControls.jsx";
import {MPubCardSimple} from "../components/mPubCard";

export function QuestionTab(props) {
   let [questionCardText, setQuestionCardText] = useState('');
   let {items} = props;
   let createQuestionCard = async () => {
      try {
         let response = await AjaxFunctions.createQuestionCard(questionCardText, Utils.getParameterByName('idIncubator', window.location.href));
         if (response.pointAwardResult) {
            ToastAlert.success(`Thank you. ${response.pointAwardResult}.`)
         }
         setQuestionCardText('');
         props.getUpdatedPortfolioData();
      } catch (err) {
         ToastAlert.error(err)
      }
   }
   return (
      <div>
         <div className='new-thread-box'>
            <Typography variant='h6'>
               Submit a question to the sponsor.
            </Typography>
            <MultiLineTextField
               data={questionCardText}
               onChange={e => setQuestionCardText(e.target.value)}
               maxLength='1000'
               rows={3}
            />
            <Button variant='outlined' color='primary' disabled={questionCardText.trim() === ''} onClick={() => createQuestionCard()}>
               Submit
            </Button>
         </div>
         {items.map(card => {
            return (
               <div style={{ marginBottom: '1em' }} key={`${card.cardType}_${card.id}`}>
                  <MPubCardSimple disableLink card={card}></MPubCardSimple>
               </div>
            )
         })}
      </div>
   )
}